import inlineSVG from "inline-svg";

export const social = function (el) {
    el.querySelectorAll(".social__menu").forEach(function (menu) {
        menu.querySelectorAll("a").forEach(function (item) {
            const networkName = item.innerText.toLowerCase();
            item.innerHTML =
                '<img src="' +
                site_settings.templatePath +
                "/img/" +
                networkName +
                '.svg">';
        });
    });
    inlineSVG.init(
        {
            svgSelector: ".social__menu img",
            initClass: "js-inlinesvg",
        },
        function () {
            console.log("All SVGs inlined");
        }
    );
};
